export default __webpack_public_path__ + "static/media/sun.0db00825.svg";